<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepHome.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepHome.BODY')"></p>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar dark color="primary">
          <v-toolbar-side-icon v-on:click=""><v-icon>home</v-icon></v-toolbar-side-icon>
          <v-toolbar-title style="cursor: pointer;" class="white--text" v-on:click="">{{ $t('navbar.TITLE') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          {{ $route.currentRoute }}
          <v-btn round flat v-on:click="">
            <div class="hidden-xs-only">{{ this.$auth.user().username }}</div>
            <v-icon right>person</v-icon>
          </v-btn>
          <v-btn icon @click.native.stop="">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>
        <v-flex xs12 sm10 offset-sm1>
          <v-layout wrap>
          <v-flex xs12 sm6>

            <v-card color="green darken-1" class="white--text" v-ripple="{ class: 'grey--text' }" @click.native="$emit('continue')" hover height="100%">
              <v-card-title primary-title>
                <h3 class="headline pa-1"><v-icon dark x-large>question_answer</v-icon>{{ $t('main.QUESTIONNAIRE_RESP_HEAD') }}</h3>
                <v-card-text class="hidden-xs-only">{{ $t('main.QUESTIONNAIRE_RESP_DESC') }}</v-card-text>
              </v-card-title>
            </v-card>

          </v-flex>
          <v-flex xs12 sm6>

            <v-card color="green darken-1" class="white--text" v-ripple="{ class: 'grey--text' }" hover height="100%">
              <v-card-title primary-title>
                <h3 class="headline pa-1"><v-icon dark x-large>folder</v-icon>{{ $t('main.RESULTS_HEAD') }}</h3>
                <v-card-text class="hidden-xs-only">{{ $t('main.RESULTS_DESC') }}</v-card-text>
              </v-card-title>
            </v-card>

          </v-flex>
          <v-flex xs12 sm6>

            <v-card color="green darken-1" class="white--text" v-ripple="{ class: 'grey--text' }" hover height="100%">
              <v-card-title primary-title>
                <h3 class="headline pa-1"><v-icon dark x-large>view_module</v-icon>{{ $t('main.GRID_HEAD') }}</h3>
                <v-card-text class="hidden-xs-only">{{ $t('main.GRID_DESC') }}</v-card-text>
              </v-card-title>
            </v-card>

          </v-flex>

          <v-flex xs12 sm6>

            <v-card color="green darken-1" class="white--text" v-ripple="{ class: 'grey--text' }" hover height="100%">
              <v-card-title primary-title>
                <h3 class="headline pa-1"><v-icon dark x-large>contact_support</v-icon>{{ $t('main.TUTORIAL_HEAD') }}</h3>
                <v-card-text class="hidden-xs-only">{{ $t('main.TUTORIAL_DESC') }}</v-card-text>
              </v-card-title>
            </v-card>

          </v-flex>

            <main-page-button :title="$t('main.TUTORIAL_HEAD')" :subtitle="$t('main.TUTORIAL_DESC')"
                                     icon="contact_support"></main-page-button>
          </v-layout>
        </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
    <v-container>
      <v-layout>
        <v-btn @click.native="$emit('back')" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'tutorial-step5'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStep5.vue